import { createSlice, isAnyOf } from '@reduxjs/toolkit'

import { fetchUserAccountDetailsAsync } from '../actions/accountActions';
import { USER_DATA } from 'src/app/_interfaces/auth.interface';
import { isImpersonationSessionActive } from 'src/utils/impersonationTokens'
type fetchUserAccountPayoad = {
  fetchedUserAccountData: USER_DATA | null
  fetchedUserStaffData: USER_DATA | null
  fetchedUserAccountLoading: boolean
}

const initialState: fetchUserAccountPayoad = {
  fetchedUserAccountData: null,
  fetchedUserStaffData: null,
  fetchedUserAccountLoading: false,
}

const fetchUserAccountDataSlice = createSlice({
  name: 'fetchUserAccountDataSlice',
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(fetchUserAccountDetailsAsync.pending), (state, action) => {
      state.fetchedUserAccountLoading = true
    })
    builder.addMatcher(
      isAnyOf(fetchUserAccountDetailsAsync.fulfilled),
      (state, action) => {
        const isAdminCall = action.meta.arg?.useAdminToken
        const accountType = action.payload?.account_type

        if (!isAdminCall) {
          state.fetchedUserAccountData = action.payload
        } else if (isImpersonationSessionActive()) {
          if (
            (accountType === 'ADMIN_STAFF' || accountType === 'USER_STAFF') &&
            state.fetchedUserAccountData?.parent_user_role &&
            action.payload?.role
          ) {
            state.fetchedUserStaffData = action.payload

            const parentRoles = state.fetchedUserAccountData.parent_user_role
            const staffRoles = action.payload.role

            Object.keys(parentRoles).forEach((key) => {
              if (key in staffRoles) {
                parentRoles[key] = staffRoles[key]
              }
            })
          }
        } else if (
          (accountType === 'ADMIN_STAFF' || accountType === 'USER_STAFF') &&
          state.fetchedUserAccountData?.parent_user_role &&
          action.payload?.role
        ) {
          state.fetchedUserStaffData = action.payload

          const parentRoles = state.fetchedUserAccountData.parent_user_role
          const staffRoles = action.payload.role

          Object.keys(parentRoles).forEach((key) => {
            if (key in staffRoles) {
              parentRoles[key] = staffRoles[key]
            }
          })
        } else if (
          isAdminCall &&
          accountType === 'SUPERADMIN' &&
          action.payload?.role
        ) {
          state.fetchedUserStaffData = action.payload
        } else if (!isAdminCall) {
          // NORMAL USER TOKEN RESPONSE
          state.fetchedUserAccountData = action.payload
        }

        state.fetchedUserAccountLoading = false
      }
    )
    builder.addMatcher(isAnyOf(fetchUserAccountDetailsAsync.rejected), (state) => {
      state.fetchedUserAccountLoading = false
    })
  },
  reducers: {
    getFetchedUserAccountData: (state, action: { payload: fetchUserAccountPayoad; type: string }) => {
      state.fetchedUserAccountLoading = action.payload?.fetchedUserAccountLoading
      state.fetchedUserAccountData = action?.payload.fetchedUserAccountData
    },
    clearFetchedUserAccountData: (state) => {
      state.fetchedUserAccountData = null
      state.fetchedUserStaffData = null
      state.fetchedUserAccountLoading = true
    },
  },
});

export const { getFetchedUserAccountData, clearFetchedUserAccountData } = fetchUserAccountDataSlice.actions
export default fetchUserAccountDataSlice.reducer;
